import i18n from '@/locales/i18n'
import { EVENT_CHECKPOINT_ROUTES } from '@/router/routes'
import type { RouteType } from '@/types/Route'
import { EPOIPerm } from '@/types/permissions/CheckpointsPermissionsEnum'
import CheckpointCreateView from '@/views/CheckpointsView/CheckpointCreateView.vue'
import CheckpointDetailView from '@/views/CheckpointsView/CheckpointDetailView.vue'
import { ref } from 'vue'

export enum ECheckpointRoutesNames {
    CHECKPOINT_TABLE = 'checkpointTable',
    CHECKPOINT_DETAIL = 'checkpointDetail',
    CHECKPOINT_CREATE = 'checkpointCreate'
}
export const ECheckpointRoutesNamesValues: string[] = [
    ECheckpointRoutesNames.CHECKPOINT_TABLE,
    ECheckpointRoutesNames.CHECKPOINT_DETAIL,
    ECheckpointRoutesNames.CHECKPOINT_CREATE
]

const routes: RouteType[] = [
    /* {
        path: `${EVENTS_ROUTES.detailUrl}`,
        name: ECheckpointRoutesNames.CHECKPOINT_TABLE,
        component: EventCheckpoints,
        meta: {
            title: ref(i18n.global.t('menu.events')),
            permission: EPOIPerm.CHECKPOINTS_VIEW
        }
    }, */
    {
        path: `${EVENT_CHECKPOINT_ROUTES.detailUrl}/:poiId`,
        name: ECheckpointRoutesNames.CHECKPOINT_DETAIL,
        component: CheckpointDetailView,
        meta: {
            title: ref(i18n.global.t('menu.events')),
            permission: EPOIPerm.CHECKPOINTS_VIEW
        }
    },
    {
        path: `${EVENT_CHECKPOINT_ROUTES.detailUrl}/create`,
        name: ECheckpointRoutesNames.CHECKPOINT_CREATE,
        component: CheckpointCreateView,
        meta: {
            title: ref(i18n.global.t('menu.events')),
            permission: EPOIPerm.CHECKPOINTS_EDIT
        }
    }
]

export default routes
